import React from 'react';
import _ from 'lodash';
import QRCode from "qrcode.react";
import moment from 'moment-timezone';
import { useParams, redirect, useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import './Ticket.scss';
import * as DataAPI from "./Common/DataAPI";
import constants from "./Common/constants";

const cookies = new Cookies();

const MESSAGES = constants.localeMessage;
const DEFAULT_SECONDS_INTERVAL_TO_SEND_SMS = 120; //seconds
const DEFAULT_COUNTRY_CODE = '852';
const DEFAULT_PHONE_NO_LENGTH = 8;
const TIME_ZONE = 'Asia/Hong_Kong';
const DEFAULT_EWT = '0 - 5';

class Ticket extends React.Component {
  constructor(props) {
    super();

    const query = _.split(_.replace(_.get(window, 'location.search'), '?', ''), '&')

    let lang = 'zhTW', ticketUuid = '', isFromOffline;
    _.forEach(query, item => {
      if (_.startsWith(item, 'lang')) {
        lang = _.last(_.split(item, '='));
      }

      if (_.startsWith(item, 't')) {
        ticketUuid = _.last(_.split(item, '='));
      }

      if (_.startsWith(item, 'q')) {
        isFromOffline = _.last(_.split(item, '=')) === 'Y';
      }
    });

    this.state = {
      lang,
      canSendSms: true,
      shouldShowPopupDialog: false,
      shouldShowMsgDialog: false,
      shouldShowRemark: false,
      // deviceId: _.get(props.params, 'deviceId'),
      // queueId: _.get(props.params, 'queueId'),
      // myTicket: _.get(props.params, 'myTicket'),
      queues: [],
      queueSelected: null,
      locations: [],
      locationSelected: null,
      ttlNoOfPendingTickets: '-',
      popupDialogData: null,
      phoneNumberInputted: '',
      verificationCodeInputted: '',
      // shouldShowTicketPassed: false,
      step: 1, // 1: Centre Selection, 2: Queue Selection, 3: SMS Verification, 4: Ticket Status, 5: Ticket Cancelled
      timeToGetNextCode: null,
      secondsIntervalToSendSms: DEFAULT_SECONDS_INTERVAL_TO_SEND_SMS,
      countryCode: DEFAULT_COUNTRY_CODE,
      phoneNumberLength: DEFAULT_PHONE_NO_LENGTH,
      isAgreeTelNoUsage: false,
      shouldReceiveSms: false,
      ticketUuid: _.size(ticketUuid) ? ticketUuid : cookies.get('ticketId'),
      ticket: null,
      shouldShowQrCodePopupDialog: false,
      isFromOffline,
    };

    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.showPopupDialog = this.showPopupDialog.bind(this);
    this.hidePopupDialog = this.hidePopupDialog.bind(this);
    this.sendSMS = this.sendSMS.bind(this);
    this.navigateToQueuesSelection = this.navigateToQueuesSelection.bind(this);
    this.updateState = this.updateState.bind(this);
    this.showMsgDialog = this.showMsgDialog.bind(this);
    this.hideMsgDialog = this.hideMsgDialog.bind(this);
    this.navigateToObtainTicket = this.navigateToObtainTicket.bind(this);
    this.navigateToTicketDeleted = this.navigateToTicketDeleted.bind(this);
    this.redirectToPrebooking = this.redirectToPrebooking.bind(this);
    this.showQrCodePopupDialog = this.showQrCodePopupDialog.bind(this);
    this.hideQrCodePopupDialog = this.hideQrCodePopupDialog.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.updateRemarkToShowOrHide(this.state.step);

    if (_.size(this.state.ticketUuid)) {
      this.fetchTicket(this.state.ticketUuid, (err, ticket) => {
        if (err) return this.showMsgDialog(_.get(err, 'errors[0].message') || MESSAGES.SYSTEM_BUSY);

        if (!ticket) {
          return this.initPage();
        } else if (_.get(ticket, 'status') === 'processed') {
          this.showMsgDialog(MESSAGES.TICKET_PROCESSED_CONTACT_CS);

          return this.initPage();
        } else if (_.get(ticket, 'status') === 'cancelled') {
          if (!ticket.isOnlineCancelled) {
            this.showMsgDialog(MESSAGES.TICKET_INVALID);
          }

          return this.initPage();
        } else if (_.get(ticket, 'status') === 'invalid' && moment().tz(TIME_ZONE).diff(moment(_.get(ticket, 'invalidAt')).tz(TIME_ZONE), 'minutes') >= 30) {
          this.showMsgDialog(MESSAGES.TICKET_INVALID);

          return this.initPage();
        }

        this.refactorTicket(ticket);

        this.setState({
          ticket,
        }, () => {
          this.setState({
            step: 4,
          });

          this.notifySqsIsFromOffline(ticket.uuid);
        });
      });
    } else {
      this.initPage();
    }
  }

  initPage() {
    const refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lang=' + this.state.lang;
    window.history.pushState({ path: refresh }, '', refresh);
    this.getConfig();
    this.getLocations(() => {
      this.notifyParent();
    });
  }

  notifySqsIsFromOffline(ticketUuid) {
    DataAPI.post(`${constants.onlineTicketDomain}/api/public/isSqsTicket/${ticketUuid}`, {}, (err, config) => {
      if (err) {
        console.error('notifySqsIsFromOffline error:', err);
        return;
      }
    });
  }

  getConfig(cb = constants.emptyFnc) {
    DataAPI.get(`${constants.onlineTicketDomain}/api/public/config`, {}, (err, config) => {
      if (err) {
        console.error('getConfig error:', err);
        return cb(err);
      }

      this.setState({
        secondsIntervalToSendSms: _.get(config, 'secondsIntervalToSendSms'),
        countryCode: _.get(config, 'countryCode'),
        phoneNumberLength: _.get(config, 'phoneNumberLength'),
      }, cb);
    });
  }

  redirectToHomePageIfTicketDisabled(cb = constants.emptyFnc) {
    this.getLocations(() => {
      const locationSelected = this.state.locationSelected || _.get(this.state.ticket, 'location');
      const location = _.find(this.state.locations, { _id: _.get(locationSelected, '_id') });

      if (location.canTakeTicket) {
        cb();
      } else {
        this.showMsgDialog(MESSAGES.TICKET_PAUSED);
        this.setState({
          step: 1,
        }, this.initPage);
      }
    });
  }

  getLocations(nextAction = constants.emptyFnc) {
    DataAPI.get(`${constants.onlineTicketDomain}/api/public/locations`, {}, (err, locations) => {
      if (err) return console.error('locations error:', err);

      this.setState({
        locations,
      }, () => {
        nextAction();
      });
    });
  }

  // getQueue() {
  //   DataAPI.get(`${constants.onlineTicketDomain}/api/public/queue/${this.state.queueId}`, {}, (err, queue) => {
  //     if (err) return console.error('queue error:', err);
  //
  //     _.set(queue, 'lastNumberToShow', _.padStart(queue.lastNumber, queue.numberOfDigit, '0'));
  //
  //     const myTicketNumber = _.toNumber(_.join(_.drop(_.split(this.state.myTicket, '')), ''));
  //     const shouldShowTicketPassed = queue.lastNumber > myTicketNumber;
  //
  //     this.setState({
  //       queue,
  //       shouldShowTicketPassed,
  //     });
  //   });
  // }

  notifyParent() {
    window.top.postMessage('load resize', '*');
    window.top.postMessage('getHeight-' + document.body.scrollHeight || document.body.offsetHeight || document.body.clientHeight, '*');
  }

  postTicketToParent(ticketUuid) {
    window.top.postMessage('getCode@' + ticketUuid, '*');
  }

  notifyParentScrollToPopup() {
    const element = _.head(document.getElementsByClassName("popup"));

    if (element.getBoundingClientRect) {
      const top = _.get(element.getBoundingClientRect(), 'top');
      window.top.postMessage('scrolltop@' + top, '*');
    }
  }

  notifyParentScrollToTop() {
    window.top.postMessage('scrolltop@0', '*');
  }

  nextStep() {
    this.redirectToHomePageIfTicketDisabled(() => {
      const step = this.state.step + 1;

      this.setState({
        step,
      }, this.notifyParent);

      this.hidePopupDialog();
      this.updateRemarkToShowOrHide(step);
      window.scrollTo(0, 0);
      this.notifyParentScrollToTop();
    });
  }

  previousStep() {
    this.redirectToHomePageIfTicketDisabled(() => {
      const step = this.state.step - 1;

      this.setState({
        step,
      }, this.notifyParent);

      this.updateRemarkToShowOrHide(step);
      window.scrollTo(0, 0);
      this.notifyParentScrollToTop();
    });
  }

  showPopupDialog(data) {
    this.setState({
      shouldShowPopupDialog: true,
      popupDialogData: data,
    }, () => {
      this.notifyParentScrollToPopup();
    });
  }

  hidePopupDialog() {
    this.setState({
      shouldShowPopupDialog: false,
      popupDialogData: null,
    });
  }

  showQrCodePopupDialog() {
    this.setState({
      shouldShowQrCodePopupDialog: true,
    }, () => {
      this.notifyParentScrollToPopup();
    });
  }

  hideQrCodePopupDialog() {
    this.setState({
      shouldShowQrCodePopupDialog: false,
    });
  }

  showMsgDialog(data) {
    this.setState({
      shouldShowMsgDialog: true,
      msgDialogData: data,
    }, () => {
      this.notifyParentScrollToPopup();
    });
  }

  hideMsgDialog() {
    this.setState({
      shouldShowMsgDialog: false,
      msgDialogData: null,
    });
  }

  updateRemarkToShowOrHide(step) {
    const shouldShowRemark = {
      1: true,
      2: true,
      3: true,
      4: false,
      5: false,
    }[step];

    this.setState({
      shouldShowRemark,
    });
  }

  navigateToLocationsSelection(nextAction = constants.emptyFnc) {
    this.getLocations(() => {
      nextAction();
    });
  }

  navigateToQueuesSelection(location, nextAction = constants.emptyFnc) {
    DataAPI.get(`${constants.onlineTicketDomain}/api/public/queues/${location._id}`, {}, (err, result) => {
      if (err) return console.error('queues error:', err);

      let { queues, noOfPendingTickets } = result;

      queues = _.map(queues, queue => {
        _.set(queue, 'lastCalledNumberToShow', _.padStart(queue.lastCalledNumber, queue.numberOfDigit, '0'));
        _.set(queue, 'nextNumberToShow', _.padStart(queue.nextNumber, queue.numberOfDigit, '0'));

        return queue;
      });

      this.setState({
        locationSelected: location,
        queues,
        ttlNoOfPendingTickets: noOfPendingTickets,
      }, () => {
        nextAction();
      });
    });
  }

  navigateToSmsVerification(queue) {
    this.setState({
      queueSelected: queue,
      timeToGetNextCode: moment().tz(TIME_ZONE),
    }, () => {
      this.nextStep();

      setInterval(() => {
        this.refreshSmsLeftSeconds();
      }, 500);
    });
  }

  sendSMS(phoneNumber) {
    if (_.size(phoneNumber) !== this.state.phoneNumberLength || _.toString(_.toNumber(phoneNumber)) !== _.toString(phoneNumber)) return this.showMsgDialog(MESSAGES.WRONG_PHONE_NO);

    DataAPI.post(`${constants.onlineTicketDomain}/api/public/sendVerificationCode/${this.state.locationSelected._id}/${this.state.countryCode}/${phoneNumber}`, {
      lang: this.state.lang,
    }, (err) => {
      if (err) return this.showMsgDialog(_.get(err, 'errors[0].message') || MESSAGES.SYSTEM_BUSY);

      this.setState({
        timeToGetNextCode: moment().tz(TIME_ZONE).add(this.state.secondsIntervalToSendSms, 'seconds'),
      });
    });
  }

  updateState(key, type, e) {
    const value = type === 'checkbox' ? _.get(e, 'target.checked') : _.get(e, 'target.value');

    this.setState({
      [key]: value,
    });
  }

  refreshSmsLeftSeconds() {
    const secondsLeft = moment(this.state.timeToGetNextCode).tz(TIME_ZONE).diff(moment().tz(TIME_ZONE), 'seconds');
    const secondsLeftToEnableSms = secondsLeft <= 0 ? 0 : secondsLeft;

    this.setState({
      secondsLeftToEnableSms,
      canSendSms: secondsLeftToEnableSms === 0,
    });
  }

  fetchTicket(uuid, cb) {
    DataAPI.get(`${constants.onlineTicketDomain}/api/public/ticket/${uuid}`, {}, cb);
  }

  navigateToObtainTicket(countryCode, phoneNumber, code, queueId, shouldReceiveSms) {
    if (_.size(phoneNumber) !== this.state.phoneNumberLength || _.toString(_.toNumber(phoneNumber)) !== _.toString(phoneNumber)) return this.showMsgDialog(MESSAGES.WRONG_PHONE_NO);
    if (!this.state.isAgreeTelNoUsage) return this.showMsgDialog(MESSAGES.CLICK_TO_AGREE_TEL_NO_USAGE);
    if (!_.size(code)) return this.showMsgDialog(MESSAGES.WRONG_VERIFICATION_CODE);

    this.redirectToHomePageIfTicketDisabled(() => {
      DataAPI.put(`${constants.onlineTicketDomain}/api/public/verifyCodeAndObtainTicket/${countryCode}/${phoneNumber}/${code}/${queueId}`, {
        shouldReceiveSms,
        lang: this.state.lang,
      }, (err, result) => {
        if (err || !_.size(_.get(result, 'ticketId'))) return this.showMsgDialog(_.get(err, 'errors[0].message') || MESSAGES.SYSTEM_BUSY);

        const ticketUuid = _.get(result, 'ticketId');
        const expires = moment().tz(TIME_ZONE).endOf('day').toDate();
        cookies.set('ticketId', ticketUuid, { expires, path: '/' });
        const refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lang=' + this.state.lang + '&t=' + ticketUuid;
        window.history.pushState({ path: refresh }, '', refresh);
        this.postTicketToParent(ticketUuid);

        this.fetchTicket(ticketUuid, (err, ticket) => {
          if (err || !ticket) return this.showMsgDialog(_.get(err, 'errors[0].message') || MESSAGES.SYSTEM_BUSY);

          this.refactorTicket(ticket);

          this.setState({
            ticket,
            ticketUuid,
          }, this.nextStep);
        });
      });
    });
  }

  refactorTicket(ticket) {
    return _.assign(ticket, {
      lastCalledNumberToShow: _.padStart(ticket.lastCalledNumber, ticket.numberOfDigit, '0'),
      numberToShow: _.padStart(ticket.number, ticket.numberOfDigit, '0'),
    });
  }

  navigateToTicketDeleted() {
    DataAPI.post(`${constants.onlineTicketDomain}/api/public/deleteTicket/${this.state.ticketUuid}`, {}, (err) => {
      if (err) return this.showMsgDialog(_.get(err, 'errors[0].message') || MESSAGES.UNKNOWN_ERROR);

      const refresh = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lang=' + this.state.lang;
      window.history.pushState({ path: refresh }, '', refresh);
      cookies.remove('ticketId');
      window.top.postMessage('cancelTicket', '*');

      this.nextStep();
    });
  }

  reloadPage() {
    window.location.reload();
  }

  redirectToPrebooking() {
    if (this.state.lang === 'en') {
      window.top.location.href = 'https://www.samsung.com/hk_en/support/prebooking/';
    } else {
      window.top.location.href = 'https://www.samsung.com/hk/support/prebooking/';
    }
  }

  getQrCodeContent() {
    return `t=${this.state.ticketUuid}`;
  }

  render() {
    return (
      <div className={(this.state.lang === 'zhTW' ? 'zh-tw ' : 'en ') + "ticket-block"}>
        {
          this.state.shouldShowMsgDialog &&
          <div className="popup">
            <div className="popup-wrapper">
              <div className="ic ic-atten" />
              <div className="text-content">
                {_.get(this.state.msgDialogData, `${this.state.lang}`, '')}
              </div>
              <div className="action-buttons">
                <a
                  onClick={this.hideMsgDialog}
                  className="btn outline">
                  {MESSAGES.OK[this.state.lang]}</a>
              </div>
              <div className="back" />
            </div>
          </div>
        }
        <div className="top-header">{MESSAGES.ONLINE_QUEUING[this.state.lang]}</div>

        {
          this.state.step === 1 &&
          <div className="center-selection-block">
            <div className="main-banner" style={{
              backgroundImage: "url('./banner.jpg')",
            }}>
              <div className="top">
                <div className="text-content">
                  {MESSAGES.HOME_PAGE_HEADER_1[this.state.lang]}
                  <br />
                  {MESSAGES.HOME_PAGE_HEADER_2[this.state.lang]}
                  {
                    this.state.lang === 'en' ?
                      ' '
                      :
                      <br />
                  }
                  {MESSAGES.HOME_PAGE_HEADER_3[this.state.lang]}
                </div>
              </div>
              <div className="bottom">
                <div className="text-content">
                  <div className="sub-li">
                    <div className="lt">{MESSAGES.QUEUE[this.state.lang]}</div>
                    <div className="rt">{MESSAGES.QUEUE_SENTENCE[this.state.lang]}</div>
                  </div>
                  <div className="sub-li">
                    <div className="lt">{MESSAGES.PRE_BOOK[this.state.lang]}</div>
                    <div className="rt">{MESSAGES.PRE_BOOK_SENTENCE[this.state.lang]}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-block">
              <div className="shop-lists">
                {
                  _.map(this.state.locations, (location, index) => (
                    <div key={index} className="shop-list">
                      <div className="shop-list-wrapper">
                        <div className="lt">
                          <div className="name">{location.name[this.state.lang]}</div>
                          <div className="address">{location.address[this.state.lang]}</div>
                          <div
                            className="open-time-label">{MESSAGES.OPERATING_HOURS[this.state.lang]}</div>
                          <div
                            className="open-time">{location.operatingHours[this.state.lang]}</div>
                          {/*<div*/}
                          {/*  className="location-remark">{MESSAGES.LOCATION_REMARK[this.state.lang]}</div>*/}
                        </div>
                        <div className="rt">
                          <div className="action-buttons">
                            {
                              location.canTakeTicket &&
                              <a className="btn outline"
                                 onClick={this.navigateToQueuesSelection.bind(this, location, this.nextStep)}>{MESSAGES.QUEUE[this.state.lang]}</a>
                            }
                            <a onClick={this.redirectToPrebooking}
                               className="btn fill">{MESSAGES.PRE_BOOK[this.state.lang]}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        }

        {
          this.state.step === 2 &&
          <div className="queue-selection-block">
            <div className="main-block">

              <div className="shop-lists">
                <div className="shop-list">
                  <div className="shop-list-wrapper">
                    <div className="lt">
                      <div className="name">
                        {this.state.locationSelected.name[this.state.lang]}
                      </div>
                      <div className="address">
                        {this.state.locationSelected.address[this.state.lang]}
                      </div>
                      <div className="open-time-label">
                        {MESSAGES.OPERATING_HOURS[this.state.lang]}
                      </div>
                      <div className="open-time">
                        {this.state.locationSelected.operatingHours[this.state.lang]}
                      </div>
                    </div>
                    <div className="rt">
                      <div className="current-count">
                        <div className="label">
                          {MESSAGES.NO_OF_TICKET_WAITING[this.state.lang]}:
                        </div>
                        <div className="value">{this.state.ttlNoOfPendingTickets}</div>
                      </div>
                    </div>
                  </div>
                  <div className="reminder-block">{MESSAGES.REMINDER_1[this.state.lang]}</div>
                </div>
              </div>

              <div className="service-lists">
                <div className="sub-header">{MESSAGES.SELECT_SERVICE_TYPE[this.state.lang]}</div>

                {
                  _.map(this.state.queues, (queue, index) => (
                    <div key={index} className="service-list">
                      <div className="title">
                        {queue.prefix}. <span>{queue.name[this.state.lang]}</span>
                      </div>
                      <div className="table">
                        <div className="current">
                          <div className="label">{MESSAGES.NOW_SERVING[this.state.lang]}</div>
                          <div className="value">{queue.prefix + queue.lastCalledNumberToShow}</div>
                        </div>
                        <div className="now">
                          <div className="label">
                            {MESSAGES.NEXT_TICKET_NUMBER[this.state.lang]}
                          </div>
                          <div className="value">{queue.prefix + queue.nextNumberToShow}</div>
                        </div>
                        <div className="time">
                          <div className="label">{MESSAGES.EST_WAITING_TIME[this.state.lang]}</div>
                          <div className="value">
                            {
                              queue.shouldShowWaitingTime ?
                                (`${queue.waitingTimeFrom === queue.waitingTimeTo ? queue.waitingTimeFrom : (queue.waitingTimeFrom + ' - ' + queue.waitingTimeTo)} ${MESSAGES.MINS[this.state.lang]}`)
                                :
                                DEFAULT_EWT + ' ' + MESSAGES.MINS[this.state.lang]
                            }
                          </div>
                        </div>
                      </div>
                      <div className="action-buttons">
                        <a
                          onClick={_.size(_.get(queue, `popUpMsg.${this.state.lang}`)) ? this.showPopupDialog.bind(this, { queue }) : this.navigateToSmsVerification.bind(this, queue)}
                          className="btn outline">{MESSAGES.SELECT[this.state.lang]}</a>
                      </div>
                    </div>
                  ))
                }
              </div>

              <div className="back">
                <a
                  onClick={this.navigateToLocationsSelection.bind(this, this.previousStep)}>{MESSAGES.BACK[this.state.lang]}</a>
              </div>

            </div>
            {
              this.state.shouldShowPopupDialog &&
              <div className="popup">
                <div className="popup-wrapper">
                  <div className="ic ic-atten" />
                  <div className="text-content">
                    {_.get(this.state.popupDialogData, `queue.popUpMsg.${this.state.lang}`)}
                    {/*維修過程資料會被清除，*/}
                    {/*<br />*/}
                    {/*客人需於維修前自行備份資料。*/}
                  </div>
                  <div className="action-buttons">
                    <a
                      onClick={this.navigateToSmsVerification.bind(this, _.get(this.state.popupDialogData, 'queue'))}
                      className="btn outline">
                      {MESSAGES.NEXT[this.state.lang]}</a>
                  </div>
                  <div className="back">
                    <a onClick={this.hidePopupDialog}>{MESSAGES.BACK[this.state.lang]}</a>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        {
          this.state.step === 3 &&
          <div className="verification-block">
            <div className="main-block">
              <div className="shop-lists">
                <div className="shop-list">
                  <div className="shop-list-wrapper">
                    <div className="lt">
                      <div className="name">
                        {this.state.locationSelected.name[this.state.lang]}
                      </div>
                      <div className="address">
                        {this.state.locationSelected.address[this.state.lang]}
                      </div>
                      <div
                        className="open-time-label">{MESSAGES.OPERATING_HOURS[this.state.lang]}</div>
                      <div className="open-time">
                        {this.state.locationSelected.operatingHours[this.state.lang]}
                      </div>
                    </div>
                    <div className="rt">
                      <div className="current-count">
                        <div className="label">{MESSAGES.NO_OF_TICKET_WAITING[this.state.lang]}:
                        </div>
                        <div className="value">{this.state.ttlNoOfPendingTickets}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="verify">
                <div className="sub-header">{MESSAGES.SMS_VERIFICATION[this.state.lang]}</div>
                <form>
                  <div className="input-fields">
                    <div className="input-field">
                      <div className="phone-field">
                        <div className="zone">+{this.state.countryCode}</div>
                        <input type="number"
                               placeholder={MESSAGES.MOBILE_NUMBER[this.state.lang]}
                               disabled={!this.state.canSendSms}
                               onChange={this.updateState.bind(this, 'phoneNumberInputted', 'number')} />
                      </div>
                      <div className="action-buttons">
                        <a onClick={this.sendSMS.bind(this, this.state.phoneNumberInputted)}
                           className={(this.state.canSendSms ? '' : 'disabled ') + "btn outline"}>
                          {this.state.canSendSms ? MESSAGES.VERIFY[this.state.lang] : MESSAGES.SENT[this.state.lang]}
                        </a>
                      </div>
                    </div>
                    {
                      !this.state.canSendSms &&
                      <div className="resend-note">
                        {
                          this.state.lang === 'en' ?
                            MESSAGES.RETRIEVE_AFTER[this.state.lang] + ' ' + this.state.secondsLeftToEnableSms + ' ' + MESSAGES.SECONDS[this.state.lang]
                            :
                            this.state.secondsLeftToEnableSms + MESSAGES.SECONDS[this.state.lang] + MESSAGES.RETRIEVE_AFTER[this.state.lang]
                        }
                      </div>
                    }
                    <div className="input-field">
                      <div className="verify-field">
                        <input type="number"
                               placeholder={MESSAGES.VERIFICATION_CODE[this.state.lang]}
                               onChange={this.updateState.bind(this, 'verificationCodeInputted', 'number')} />
                      </div>
                      <div className="action-buttons">
                        <a
                          onClick={this.navigateToObtainTicket.bind(this, this.state.countryCode, this.state.phoneNumberInputted, this.state.verificationCodeInputted, _.get(this.state.queueSelected, '_id'), this.state.shouldReceiveSms)}
                          className="btn outline">{MESSAGES.CONFIRM[this.state.lang]}</a>
                      </div>
                    </div>
                  </div>
                  <div className="checkbox-fields">
                    <div className="checkbox">
                      <input type="checkbox" required id="check1"
                             checked={this.state.isAgreeTelNoUsage}
                             onChange={this.updateState.bind(this, 'isAgreeTelNoUsage', 'checkbox')} />
                      <label htmlFor="check1">
                        <div className="text-content">
                          {MESSAGES.SMS_OPTIONS_1[this.state.lang]}
                        </div>
                      </label>
                    </div>
                    <div className="checkbox">
                      <input type="checkbox" required id="check2"
                             checked={this.state.shouldReceiveSms}
                             onChange={this.updateState.bind(this, 'shouldReceiveSms', 'checkbox')} />
                      <label htmlFor="check2">
                        <div className="text-content">
                          {MESSAGES.SMS_OPTIONS_2[this.state.lang]}
                          <span>{MESSAGES.SMS_OPTIONS_2_SUB[this.state.lang]}</span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="remark-lists">
                    <div className="remark-list">{MESSAGES.SMS_REMARKS_1[this.state.lang]}</div>
                    <div className="remark-list">{MESSAGES.SMS_REMARKS_2[this.state.lang]}</div>
                    <div className="remark-list">{MESSAGES.SMS_REMARKS_3[this.state.lang]}</div>
                  </div>
                </form>
              </div>
              <div className="back">
                <a
                  onClick={this.navigateToQueuesSelection.bind(this, this.state.locationSelected, this.previousStep)}>
                  {MESSAGES.BACK[this.state.lang]}
                </a>
              </div>

            </div>
          </div>
        }

        {
          this.state.step === 4 &&
          <div className="ticket-status-block">
            <div className="main-block">
              <div className="shop-lists">
                <div className="shop-list">
                  <div className="shop-list-wrapper">
                    <div className="lt">
                      <div
                        className="name">{_.get(this.state.ticket, `location.name.${this.state.lang}`)}</div>
                      <div
                        className="address">{_.get(this.state.ticket, `location.address.${this.state.lang}`)}</div>
                      <div
                        className="open-time-label">{MESSAGES.OPERATING_HOURS[this.state.lang]}</div>
                      <div
                        className="open-time">{_.get(this.state.ticket, `location.operatingHours.${this.state.lang}`)}</div>
                    </div>
                    <div className="rt"></div>
                  </div>
                </div>
              </div>

              <div className="result">
                <div className="type-title">
                  {_.get(this.state.ticket, 'queuePrefix')}. <span>{_.get(this.state.ticket, `queueName.${this.state.lang}`)}</span>
                </div>

                <div className="table">
                  <div className="current">
                    <div className="label">{MESSAGES.NOW_SERVING[this.state.lang]}</div>
                    <div className="value">
                      {_.get(this.state.ticket, 'queuePrefix') + _.get(this.state.ticket, 'lastCalledNumberToShow')}
                    </div>
                  </div>
                  <div className="now">
                    <div
                      className="label highlight">{MESSAGES.YOUR_TICKET_NUMBER[this.state.lang]}</div>
                    <div className="value">
                      {_.get(this.state.ticket, 'queuePrefix') + _.get(this.state.ticket, 'numberToShow')}
                    </div>
                  </div>
                  <div className="time">
                    <div className="label">{MESSAGES.EST_WAITING_TIME[this.state.lang]}</div>
                    <div className="value">
                      {
                        _.get(this.state.ticket, 'shouldShowWaitingTime') ?
                          (
                            _.get(this.state.ticket, 'waitingTimeTo') > 0 ?
                              (`${_.get(this.state.ticket, 'waitingTimeFrom') === _.get(this.state.ticket, 'waitingTimeTo') ? _.get(this.state.ticket, 'waitingTimeFrom') : (_.get(this.state.ticket, 'waitingTimeFrom') + ' - ' + _.get(this.state.ticket, 'waitingTimeTo'))} ${MESSAGES.MINS[this.state.lang]}`)
                              :
                              (DEFAULT_EWT + ' ' + MESSAGES.MINS[this.state.lang])
                          )
                          :
                          '--'
                      }
                    </div>
                  </div>
                </div>

                <div className="ticket-info">
                  <div className="get-time">
                    <div className="label">{MESSAGES.TICKET_ISSUE_TIME[this.state.lang]}</div>
                    <div className="value">
                      {moment(_.get(this.state.ticket, 'createdAt')).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm:ss')}
                    </div>
                  </div>
                  <div className="on-time">
                    <div className="label">{MESSAGES.TICKET_CALL_TIME[this.state.lang]}</div>
                    <div className="value">
                      {_.get(this.state.ticket, 'calledAt') ? moment(_.get(this.state.ticket, 'calledAt')).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm:ss') : '-- : -- : --'}
                    </div>
                  </div>
                  <div className="update-time">
                    <div className="label">{MESSAGES.STATUS_LAST_UPDATED[this.state.lang]}</div>
                    <div className="value">
                      {moment(_.get(this.state.ticket, 'updatedAt')).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm:ss')}
                    </div>
                  </div>
                </div>

                <div className="reminder-block">
                  {MESSAGES.REMINDER_2[this.state.lang]}
                </div>

                {
                  _.get(this.state.ticket, 'location.allowRequeue') &&
                  <div className="requeue-qrcode-block">
                    <a className="text" onClick={this.showQrCodePopupDialog}>
                      {MESSAGES.SHOW_QR_CODE[this.state.lang]}
                    </a>
                  </div>
                }

                <div className="action-buttons">
                  <a onClick={this.showPopupDialog} className="btn outline">
                    {MESSAGES.CANCEL[this.state.lang]}</a>
                  <a onClick={this.redirectToPrebooking}
                     className="btn fill">{MESSAGES.PRE_BOOK[this.state.lang]}</a>
                </div>
              </div>
            </div>

            {
              this.state.shouldShowQrCodePopupDialog &&
              <div className="popup">
                <div className="popup-wrapper">
                  <div className="text-content">
                    {MESSAGES.SHOW_QR_CODE_REQUEUE[this.state.lang]}
                  </div>
                  <QRCode
                    size={250}
                    value={this.getQrCodeContent()} />
                  <div className="back">
                    <a onClick={this.hideQrCodePopupDialog}>{MESSAGES.CLOSE[this.state.lang]}</a>
                  </div>
                </div>
              </div>
            }
            {
              this.state.shouldShowPopupDialog &&
              <div className="popup">
                <div className="popup-wrapper">
                  <div className="ic ic-atten" />
                  <div className="text-content">
                    {MESSAGES.CANCEL_TICKET_Q[this.state.lang]}
                  </div>
                  <div className="action-buttons">
                    <a onClick={this.navigateToTicketDeleted} className="btn outline">
                      {MESSAGES.CONFIRM[this.state.lang]}</a>
                  </div>
                  <div className="back">
                    <a onClick={this.hidePopupDialog}>{MESSAGES.BACK[this.state.lang]}</a>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        {
          this.state.step === 5 &&
          <div className="ticket-cancelled-block">
            <div className="msg-block">
              <div className="ic ic-atten" />
              <div className="text-content">
                {MESSAGES.TICKET_CANCEL_CONFIRMED_1[this.state.lang]}
                <br />
                {MESSAGES.TICKET_CANCEL_CONFIRMED_2[this.state.lang]}
              </div>
              <div className="action-buttons">
                <a onClick={this.reloadPage} className="btn outline">
                  {MESSAGES.GET_NEW_TICKET[this.state.lang]}
                </a>
              </div>
            </div>
          </div>
        }

        {
          this.state.shouldShowRemark &&
          <div className="remark">
            {MESSAGES.REMARK_1[this.state.lang]}
            <br />
            {MESSAGES.REMARK_2[this.state.lang]}
          </div>
        }
      </div>
    )
  }
}

const TicketParams = (props) => (
  <Ticket
    {...props}
    params={useParams()}
  />
)

export default TicketParams;
